import { useContext, useEffect, useRef, useState } from "react";
import {
  BackGroundModalAside,
  ContainerRightAside,
  Div,
} from "../../Styles/Styled";
import { FaTimesCircle, FaTrash } from "react-icons/fa";
import { GestorContext } from "../../store/GestorStore";
import { useNavigate } from "react-router-dom";
import ModalProduto from "../ModalProds";
import { Colors } from "../../config";

interface IProd {
  chave: number;
  descricao: string;
  preco_venda: number;
  grupo1: string;
  grupo2: string;
  grupo3: string;
  quantidade: number;
  observacao: string;
  tipo: string;
  kits?: any[];
  extras: IExtraProd[];
  picture: string;
  observacao_produto?: string;
}

interface IExtraProd {
  chave: number;
  descricao: string;
  quantidade: number;
  ordem: number;
  qme: number;
  preco_venda: number;
  chave_kit: number;
}

interface RigthAsideProps {
  open: boolean;
  onCloseAside: Function;
}

export default function RightAside(props: RigthAsideProps) {
  const Gestor = useContext(GestorContext);
  const [prodsCart, setProdsCart] = useState<IProd[]>([]);
  const [prodDetail, setProdDetail] = useState<IProd | null>(null);
  const [open, setOpen] = useState(props.open);
  const navigate = useNavigate();

  useEffect(() => {
    setOpen(props.open);
  }, [props]);

  useEffect(() => {
    if (Gestor) {
      setProdsCart(Gestor.state.carrinho);
    }
  }, [Gestor]);

  useEffect(() => {
    const handleClick = (e: any) => {
      if (e.target.id === "background-opacity") {
        props.onCloseAside();
      }
    };

    const element = window;

    element.addEventListener("click", handleClick);

    // 👇️ remove the event listener when the component unmounts
    return () => {
      element.removeEventListener("click", handleClick);
    };
  }, []);

  const GoToCart = () => {
    navigate("/carrinho");
  };

  return (
    <>
      {prodDetail && (
        <ModalProduto
          open={false}
          {...prodDetail}
          onPressClose={() => setProdDetail(null)}
        />
      )}
      <BackGroundModalAside open={props.open} id="background-opacity">
        <ContainerRightAside Open={open} id="RightAside" style={{
          background: Colors.header,
        }}>
          <Div
            Content="center"
            Items={"center"}
            Margin={{ top: "5px", bottom: "5px" }}
            Height={"15vh"}
            Width={"15vh"}
            background={Colors.headerCircleColor}
            style={{ borderRadius: "50%" }}
          >
            <img
              src="./logo.png"
              style={{
                maxHeight: "14vh",
                borderRadius: '50%',
                width: "100%",
                objectFit: "contain",
              }}
            />
          </Div>
          <span>Produtos</span>
          <div
            style={{
              height: "56vh",
              width: "100%",
              overflow: "scroll",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {prodsCart.map((e) => {
              const valor_extras = e?.extras
                ?.filter((e) => e.ordem == 99)
                ?.reduce((a: number, b) => {
                  return a + b?.preco_venda * b?.quantidade;
                }, 0);
              const preco =
                (parseFloat(`${e.preco_venda}`) + valor_extras) * e.quantidade;
              return (
                <div
                  onClick={() => setProdDetail(e)}
                  style={{
                    width: "90%",
                    flexDirection: "column",
                    position: "relative",
                    display: "flex",
                    flexWrap: "nowrap",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: 10,
                    padding: 5,
                    marginBottom: 10,
                    border: "2px solid white",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      flexDirection: "row",
                      display: "flex",
                      flexWrap: "nowrap",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <img
                      style={{
                        width: "25%",
                        maxHeight: 100,
                        objectFit: "contain",
                        borderRadius: 5,
                      }}
                      onError={(e: any) => (e.target.src = "./notfound.png")}
                      src={e.picture}
                    />
                    <div
                      style={{
                        width: "35%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          color: "#FFF",
                          fontSize: "0.75em",
                          textAlign: "left",
                        }}
                      >
                        {e.descricao}
                      </div>
                      <div
                        style={{
                          marginTop: 5,
                          color: "#FFF",
                          fontSize: "0.75em",
                          textAlign: "left",
                        }}
                      >
                        QTD: {e.quantidade}{" "}
                        {e?.extras &&
                          e?.extras[0] &&
                          `Adicinais: ${e?.extras?.length}`}
                      </div>
                    </div>
                    <div
                      style={{
                        marginTop: 5,
                        color: "#FFF",
                        fontSize: "0.85em",
                        textAlign: "left",
                      }}
                    >
                      R$
                      {new Intl.NumberFormat("pt-BR", {
                        minimumFractionDigits: 2,
                      }).format(preco)}
                    </div>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                    }}
                  >
                    <FaTrash size={"0.85em"} color="white" />
                  </div>
                </div>
              );
            })}
          </div>
          <div
            style={{
              height: "15vh",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span style={{ marginTop: 10, marginBottom: 10 }}>
              {" "}
              Total: R$
              {new Intl.NumberFormat("pt-BR", {
                minimumFractionDigits: 2,
              }).format(
                prodsCart.reduce((a, u) => {
                  const extra = u?.extras
                    ?.filter((f: any) => f?.ordem === 99)
                    ?.reduce((c, b) => {
                      return c + b?.preco_venda * b?.quantidade;
                    }, 0);
                    console.log(extra);
                  const valor = (parseFloat(`${u.preco_venda}`) + extra) * u.quantidade;
                  return a + valor;
                }, 0)
              )}{" "}
            </span>

            <div
              onClick={() => GoToCart()}
              style={{
                width: "95%",
                borderRadius: "5px",
                background: Colors.headerCircleColor,
                marginBottom: 20,
                border: `2px solid ${Colors.inputHeaderBackgroundColor}`,
                height: 50,
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                letterSpacing: 1.5,
                fontWeight: 800,
              }}
            >
              <span style={{ color: Colors.inputHeaderBackgroundColor }}>Finalizar Carrinho</span>
            </div>
          </div>
        </ContainerRightAside>
      </BackGroundModalAside>
    </>
  );
}
